import { useAuth } from '@/contexts/AuthContext';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

interface Props {
  platform: 'super_admin';
  redirectTo?: string;
}

/**
 * Guards routes that require a specific platform role (e.g. super_admin).
 * Unlike RoleProtectedRoute, this checks user.platformRole, not propertyRoles.
 */
export function PlatformProtectedRoute({ platform, redirectTo = '/login' }: Props) {
  const { isLoading, isAuthenticated, user } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="size-8 animate-spin rounded-full border-2 border-border border-t-primary" />
      </div>
    );
  }

  if (!isAuthenticated || user?.platformRole !== platform) {
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  return <Outlet />;
}
